import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/images/logo.png'
import _imports_1 from '@/assets/images/home/more-icon.png'
import _imports_2 from '@/assets/images/show-list.png'
import _imports_3 from '@/assets/images/home/prev-icon.png'


const _hoisted_1 = { class: "header-box" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 0,
  src: _imports_3
}
const _hoisted_4 = ["onClick"]

import path from 'path';
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex'

type SubMenu = {
  name: string,
  path: string,
  titleIndex: number,
  pageTitle: string[]
  index?: number
}

type MenuItem = {
  title: string,
  value: SubMenu[]
  path?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderView',
  setup(__props) {

const router = useRouter()
const store = useStore()
const showListIndex = ref(-1)
const routerList: MenuItem [] = [
  {
    title: '产品服务',
    value: [
      {
        name: '数智产品',
        path: '/product_service',
        titleIndex: 1,
        pageTitle: ['产品服务', '数智产品']
      },
      {
        name: '渠道拓展',
        path: '/channel_expansion',
        titleIndex: 1,
        pageTitle: ['产品服务', '渠道拓展']
      }
    ]
  },
  {
    title: '解决方案',
    value: [
      {
        name: '文娱解决方案',
        path: '/solution',
        index: 0,
        titleIndex: 2,
        pageTitle: ['解决方案', '文娱解决方案']
      },
      {
        name: '工业解决方案',
        path: '/solution',
        index: 1,
        titleIndex: 2,
        pageTitle: ['解决方案', '工业解决方案']
      },
      {
        name: '教育解决方案',
        path: '/solution',
        index: 2,
        titleIndex: 2,
        pageTitle: ['解决方案', '教育解决方案']
      },
      {
        name: '医疗解决方案',
        path: '/solution',
        index: 3,
        titleIndex: 2,
        pageTitle: ['解决方案', '医疗解决方案']
      },
      {
        name: '军警部队解决方案',
        path: '/solution',
        index: 4,
        titleIndex: 2,
        pageTitle: ['解决方案', '军警部队解决方案']
      }
    ]
  },
  {
    title: '成功案例',
    path: "/success_cases",
    value: []
  },
  {
    title: '合作生态',
    value: [
      {
        name: '何洋 13225532650',
        path: '',
        titleIndex: 0,
        pageTitle: []
      },
    ]
  },
  {
    title: '关于我们',
    value: [
      {
        name: '公司介绍',
        path: '/about_us_view',
        titleIndex: 5,
        pageTitle: ['关于我们', '公司介绍']
      },
      {
        name: '新闻动态',
        path: '/about_us',
        titleIndex: 5,
        pageTitle: ['关于我们', '新闻动态']
      },
      {
        name: '加入我们',
        path: '/about_detail',
        titleIndex: 5,
        pageTitle: ['关于我们', '加入我们']
      }
    ]
  },
 
]

const onTitleClick = (index: number) => {

  const routerListItem = routerList[index]

  if (routerListItem.path) {

    router.push(routerListItem.path)

  } else {
    
    showListIndex.value == index ? showListIndex.value = -1 : showListIndex.value = index

  }





}

const showList = ref(false)
const changeRouter = (e: any, titleIndex: number) => {
  if (!e.path) return
  if (e.path == '/solution') {
    router.push(`${e.path}?type=${e.index}&pathName=${e.pageTitle[0]},${e.pageTitle[1]}`)
    store.state.programmeIndex = e.index
  } else {
    router.push(`${e.path}?pathName=${e.pageTitle[0]},${e.pageTitle[1]}`);
  }
  store.state.titleIndex = titleIndex;
  store.state.pageTitle = [...e.pageTitle]
  showList.value = false
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: _imports_0,
        onClick: _cache[0] || (_cache[0] = ($event: any) => {_unref(router).push('/'); showList.value = false;})
      }),
      (!showList.value)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _imports_1,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (showList.value = true))
          }))
        : _createCommentVNode("", true),
      (showList.value)
        ? (_openBlock(), _createElementBlock("img", {
            key: 1,
            src: _imports_2,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (showList.value = false))
          }))
        : _createCommentVNode("", true)
    ]),
    (showList.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "header-box-list",
          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (showList.value = false), ["stop"]))
        }, [
          _createElementVNode("div", {
            onClick: _withModifiers(($event: any) => (null), ["stop"])
          }, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(routerList, (item, index) => {
              return _createElementVNode("div", {
                key: index,
                class: _normalizeClass(["navigation-list", showListIndex.value == index ? 'active' : ''])
              }, [
                _createElementVNode("div", {
                  class: "title",
                  onClick: ($event: any) => (onTitleClick(index))
                }, [
                  _createElementVNode("span", null, _toDisplayString(item.title), 1),
                  (item.value.length > 0)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_3))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_2),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.value, (e, i) => {
                  return _withDirectives((_openBlock(), _createElementBlock("div", {
                    key: i,
                    onClick: ($event: any) => (changeRouter(e, e.titleIndex))
                  }, _toDisplayString(e.name), 9, _hoisted_4)), [
                    [_vShow, showListIndex.value == index]
                  ])
                }), 128))
              ], 2)
            }), 64))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})